var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomProductSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1094 40C14.805 40 9.71797 37.8929 5.96724 34.1421C2.21651 30.3914 0.109375 25.3043 0.109375 20C0.109375 14.6957 2.21651 9.60859 5.96724 5.85786C9.71797 2.10714 14.805 -6.32535e-08 20.1094 0L20.1094 20L20.1094 40Z",
    fill: "#009A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7148 21.5H39.6096V39.3947H22.7148V21.5Z",
    stroke: "#55AC80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 24H37.1094V37H25.1094V24Z",
    fill: "#009A59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2148 0H40.1096V18.8947H22.2148V0Z",
    fill: "#62C191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProductSearch);
export default __webpack_public_path__ + "static/media/Custom Product Search.f24a314a018ed4d45e9c78e04724c72c.svg";
export { ForwardRef as ReactComponent };